export default "/assets/images/twilight-blue-sm.webp?76abeefed967bc291b01ad1098114169";